import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const enquireService = (searchCriteria: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.POST_ENQUIRE_SERVICE_REQUEST });

  return api.authorization.enquireService.post(searchCriteria)
    .then((res: any) => {

      dispatch({
        type: types.POST_ENQUIRE_SERVICE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.POST_ENQUIRE_SERVICE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
